<template>
  <v-card tile>
    <v-card-title class="grey lighten-2">
      Arkivera händelse
    </v-card-title>

    <v-card-text class="mt-4">
      <p>
        Är du säker på att du vill arkivera händelsen?
      </p>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer />
      <v-btn rounded @click="closeModal">Avbryt</v-btn>
      <v-btn
        rounded
        type="submit"
        color="error"
        @click="onArchive"
        :loading="pending"
      >
        Arkivera
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'EventArchiveModal',

  props: {
    event: Object
  },

  data: () => ({
    pending: false
  }),

  methods: {
    async onArchive() {
      this.pending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: ArchiveEventInput!) {
            archiveEvent(payload: $payload) {
              event_uuid
            }
          }
        `,
        variables: {
          payload: {
            uuid: this.event.uuid
          }
        }
      })

      this.pending = false
      this.$store.dispatch('event/unSelectEvent')
      this.$store.commit('event/remove', this.event.uuid)
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
